import {
    CADASTRAR_USUARIOS_EMPRESA_EM_LOTE,
    LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE,
    HABILITADO_PAGAMENTO_POS
} from '../../actions/types'

const initialState = {
    retornoCadatramentoEmLote: null,
    habilitadoPagamentoViaPOS: false
};


export default function reducerUsuariosEmpresa(state = initialState, action) {

    switch (action.type) {
        case CADASTRAR_USUARIOS_EMPRESA_EM_LOTE: {
            return {
                ...state,
                retornoCadatramentoEmLote: action.payload.data,
            }
        }

        case HABILITADO_PAGAMENTO_POS: {
            return {
                ...state,
                habilitadoPagamentoViaPOS: action.payload.data
            }
        }

        case LIMPAR_RETORNO_CADASTRAMENTO_USUARIO_EMPRESA_EM_LOTE: {
            return {
                ...state,
                retornoCadatramentoEmLote: null
            }
        }

        default: {
            return state
        }
    }
}
